var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:(!_vm.$vuetify.breakpoint.mobile ? 'padding: 30px' : ''),attrs:{"fluid":!_vm.$vuetify.breakpoint.mobile}},_vm._l((_vm.$slots),function(slot,i){return _c('v-row',{key:i,attrs:{"dense":""}},[_vm._t(i)],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }